import Cookies from 'js-cookie';

up.compiler('#activation-form', el => {
  if (Cookies.get('cc_tracking') === 'true' && Cookies.get('nc') && window.fbq !== undefined) {
    window.fbq('track', 'CompleteRegistration');
    Cookies.remove('nc');
  }
})
